import React from 'react';
import { Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import SearchFilter from '@/components/SearchFilter';
import { useIsMobile } from '@/hooks/use-mobile';
import { LeadFilters } from './types/LeadTypes';
import FilterButton from '@/components/ui/FilterButton';

interface LeadListHeaderProps {
  isSearchOpen: boolean;
  isFilterOpen: boolean;
  localSearchTerm: string;
  setIsSearchOpen: (value: boolean) => void;
  setIsFilterOpen: (value: boolean) => void;
  handleSearch: (term: string) => void;
  filters?: LeadFilters;
  hasActiveFilters?: boolean;
}

const LeadListHeader: React.FC<LeadListHeaderProps> = ({
  isSearchOpen,
  isFilterOpen,
  localSearchTerm,
  setIsSearchOpen,
  setIsFilterOpen,
  handleSearch,
  filters,
  hasActiveFilters = false
}) => {
  const isMobile = useIsMobile();

  return (
    <div className="w-full max-w-screen-xl mx-auto">
      <div className={`flex items-center ${isMobile ? 'justify-between' : 'gap-4'} px-4 md:px-6`}>
        {isMobile ? (
          <>
            <h3 className="text-lg font-medium text-gray-700">Lead Activity</h3>
            <div className="flex items-center gap-2">
              <Button 
                variant={isSearchOpen ? "outline" : "ghost"}
                size="icon" 
                className="h-8 w-8 rounded-full"
                onClick={() => setIsSearchOpen(!isSearchOpen)}
              >
                <Search size={20} className={isSearchOpen ? "text-brand-green" : "text-gray-600"} />
              </Button>
              <FilterButton 
                isActive={isFilterOpen}
                hasFilters={hasActiveFilters}
                onClick={() => setIsFilterOpen(!isFilterOpen)}
              />
            </div>
          </>
        ) : (
          <>
            <h3 className="text-lg font-medium text-gray-700">Lead Activity</h3>
            <div className="flex items-center gap-2 ml-4">
              <Button 
                variant={isSearchOpen ? "outline" : "ghost"}
                size="icon" 
                className="h-8 w-8 rounded-full"
                onClick={() => setIsSearchOpen(!isSearchOpen)}
              >
                <Search size={20} className={isSearchOpen ? "text-brand-green" : "text-gray-600"} />
              </Button>
              <FilterButton 
                isActive={isFilterOpen}
                hasFilters={hasActiveFilters}
                onClick={() => setIsFilterOpen(!isFilterOpen)}
              />
              {isSearchOpen && (
                <div className="w-56">
                  <SearchFilter 
                    onSearch={handleSearch} 
                    defaultValue={localSearchTerm} 
                    className="animate-in fade-in slide-in-from-left-5 duration-300"
                  />
                </div>
              )}
            </div>
          </>
        )}
      </div>
      
      {isSearchOpen && isMobile && (
        <div className="px-4 md:px-6 mt-3 w-full">
          <SearchFilter 
            onSearch={handleSearch} 
            defaultValue={localSearchTerm} 
            className="animate-in fade-in slide-in-from-top-5 duration-300"
          />
        </div>
      )}
    </div>
  );
};

export default LeadListHeader;
